import { DataExportReq } from '@gateway.Simulation'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface DataExportConditionState {
  /** 検索条件 */
  dataExportCondition: DataExportReq
}

const initialState: DataExportConditionState = {
  dataExportCondition: {
    searchCondition: {
      reportTargetYear: new Date().getFullYear().toString(),
      reportTargetMonth: (new Date().getMonth() + 1).toString().padStart(2, '0'),
      reportFormat: '1',
      reportOutputYears: '3',
      exportTargetYearFrom: new Date().getFullYear().toString(),
      exportTargetMonthFrom: (new Date().getMonth() + 1).toString().padStart(2, '0'),
      exportTargetYearTo: new Date().getFullYear().toString(),
      exportTargetMonthTo: (new Date().getMonth() + 1).toString().padStart(2, '0'),
      branchCd: [],
      compareBranchCd: null,
      expense: [],
      buildingNo: null,
      procurementNo: null,
      constructionNm: null,
      constructionFormCd: [],
      obtainHistoryCd: [],
      evaluationValueCd: [],
      customerNm: null,
      constructionSubjectCd: null,
      totalCostFrom: null,
      totalCostTo: null,
      ourCompanyTotalCostFrom: null,
      ourCompanyTotalCostTo: null,
      obtainY: null,
      obtainM: null,
      obtainFy: [],
      constructionSectionNm: null,
      chiefPersonNm: null,
      hqSalesSectionNm: null,
      hqSalesPersonNm: null,
      branchSalesSectionNm: null,
      branchSalesPersonNm: null,
      startY: null,
      startM: null,
      completionY: null,
      completionM: null,
      constructionCd: [],
      architectureUse: [],
      structureGround: [],
      structureUnderground: [],
      specialConstructionMethod: null,
      effortLevelCd: [],
      choiceAndConcentrationTarget: [],
      procurementSts: [],
      remark: null,
      yamadumiFlg: [],
      kenzaiDiscloseFlg: [],
      supplierDiscloseFlg: []
    },
    generalPurposeSearchList: [
      {
        searchItemCd: null,
        searchItem: null,
        searchValue: null,
        searchMethodCd: null,
        searchMethod: null
      },
      {
        searchItemCd: null,
        searchItem: null,
        searchValue: null,
        searchMethodCd: null,
        searchMethod: null
      },
      {
        searchItemCd: null,
        searchItem: null,
        searchValue: null,
        searchMethodCd: null,
        searchMethod: null
      },
      {
        searchItemCd: null,
        searchItem: null,
        searchValue: null,
        searchMethodCd: null,
        searchMethod: null
      }
    ],
    outputItemList: [],
    displayStartYear: ''
  }
}

const dataExportConditionSlice = createSlice({
  name: 'dataExport',
  initialState,
  reducers: {
    setDataExportCondition: (
      state,
      action: PayloadAction<DataExportReq>
    ) => {
      state.dataExportCondition = action.payload
    }
  }
})

export const DataExportConditionActions =
  dataExportConditionSlice.actions
export const DataExportConditionReducers =
  dataExportConditionSlice.reducer
export const DataExportInitialState = initialState
